import { useQuery } from '@apollo/client';
import { ACCOUNT_SUBSCRIPTION_INFO } from '../graphql/account-info.query';

export const useAccountSubScriptionInfo = (id) => {
  return useQuery(ACCOUNT_SUBSCRIPTION_INFO, {
    variables: {
      hash: id,
    },
    fetchPolicy: 'network-only',
    skip: !id,
    notifyOnNetworkStatusChange: true,
  });
};
